/*
 * @Author: liu yang and zhan linsen
 * @Date: 2020-02-12 13:13:57
 * @LastEditTime : 2020-02-12 15:04:57
 * @LastEditors  : Please set LastEditors
 * @Description: 页面路由
 * @FilePath: \uat\src\router\router.js
 */

import Vue from "vue";
import Router from "vue-router";
// import Home from "../views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.VUE_APP_VERSION == "prod" ? 'paidvideopage2' : 'paidvideo2',
  routes: [{
      path: "/",
      name: "home",
      component: () => {
        return import("@/views/index");//首页路由
      }
    },
    {
      path: "/teacher",
      name: "teacher",
      component: () => {
        return import("@/views/teacher/teacher");//导师页路由
      }
    },
    {
      path: "/course",
      name: "course",
      component: () => {
        return import("@/views/course/course");//课程页路由
      }
    },
    {
      path: "/myvideo",
      name: "myvideo",
      component: () => {
        return import("@/views/myvideo/myvideo"); //我的课程页路由
      }
    },
    {
      path: "/coupon",
      name: "coupon",
      component: () => {
        return import("@/views/myvideo/coupon");//我的课程优惠券页路由
      }
    },
    {
      path: "/courseInfo",
      name: "courseInfo",
      component: () => {
        return import("@/views/course/courseInfo"); // 课程详情页面路由
      }
    },
    {
      path: "/teacherInfo",
      name: "teacherInfo",
      component: () => {
        return import("@/views/teacher/teacherInfo"); //导师详情页路由
      }
    },
    {
      path: "/introduce",
      name: "introduce",
      component: () => {
        return import("@/views/introduce/introduce"); //功能所引页路由
      }
    },
    {
      path: "/live",
      name: "live",
      component: () => {
        return import("@/views/live"); //直播列表页路由
      }
    },
    {
      path: "/livecourse",
      name: "livecourse",
      component: () => {
        return import("@/views/livecourse"); //直播详情页路由
      }
    }
  ]
});